module.exports = __webpack_public_path__ + "static/img/bot-step-7.670c044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-7.png
// module id = 69Hb
// module chunks = 11